import { cn } from "@/lib/utils";

export function BrandMark({ className }: { className?: string }) {
  return (
    <svg className={cn("h-7 w-7", className)} viewBox="0 0 32 32" aria-hidden="true" fill="none">
      <rect x="1" y="1" width="30" height="30" rx="7" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M7 10l5 6-5 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line x1="16" y1="22" x2="24" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
